// extracted by mini-css-extract-plugin
export var hidden = "_p0-1";
export var visible = "_p0-0";